// extracted by mini-css-extract-plugin
export default {"logoContainer":"signUpInfo_logoContainer__m1woJ","logo":"signUpInfo_logo__t84b8","title":"signUpInfo_title__HdSwH","description":"signUpInfo_description__-EAJh"};